import { useEffect } from "react";
import Player from "react-lottie-player/dist/LottiePlayerLight";

import { useSalesContext } from "../../../sales-context/SalesContext";
import { useProductOfferStore } from "../../../stores";
import { SaleProgress } from "../../../types";
import path from "./animations/Confetti.json?url";

export function ConfettiAnimation() {
    const { sessionId } = useSalesContext();
    const storesHaveFinishedRehydrating = useProductOfferStore.persist.hasHydrated();
    const showConfettiForSuccessfulSale = useProductOfferStore((state) =>
        state.getPrimaryProducts(sessionId).some((p) => p.saleProgress === SaleProgress.Success && !p.isConfettiShown),
    );
    // Play confetti animation if the product offer store has been rehydrated and there is some product with a
    // successful sale that haven't shown confetti yet.
    const playConfetti = storesHaveFinishedRehydrating && showConfettiForSuccessfulSale;
    const updateProductsConfettiStatus = useProductOfferStore((state) => state.updateProductsConfettiStatus);

    useEffect(() => {
        // Update the confetti status in the product offer store when the component unmounts.
        // This prevents the confetti animation from replaying for the same sale when switching between chats,
        // while the animation was still in progress.
        return () => updateProductsConfettiStatus(sessionId);
    }, [sessionId, updateProductsConfettiStatus]);

    return (
        <Player
            path={path}
            play={playConfetti}
            speed={0.5}
            loop={false}
            onComplete={() => updateProductsConfettiStatus(sessionId)}
        />
    );
}
